export default __webpack_public_path__ + "static/media/ujian.70e83875.svg";